module.exports = __webpack_public_path__ + "static/img/JJMC_ECGenius.7da10f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/questionBank/JJMC_ECGenius.png
// module id = W+Cf
// module chunks = 1